import activitiesController from './activitiesController'

export default activitiesController



// WEBPACK FOOTER //
// ../src/controllers/activitiesController/index.js